function Marquee(selector, speed) {
  const parentSelectors = document.querySelectorAll(selector);
  parentSelectors.forEach(function(parentSelector) {
    const clone = parentSelector.innerHTML;
    const firstElement = parentSelector.children[0];
    let i = 0;

    parentSelector.insertAdjacentHTML("beforeend", clone);
    parentSelector.insertAdjacentHTML("beforeend", clone);
    parentSelector.insertAdjacentHTML("beforeend", clone);

    setInterval(function () {
      firstElement.style.marginLeft = `-${i}px`;
      if (i > firstElement.clientWidth) {
        i = 0;
      }
      i = i + speed;
    }, 0);
  });
}

window.addEventListener("load", function() {
  Marquee(".boolland_marquee", 0.25);
});
